import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TR, TD } from "../primitives/Table.js";
import { StatusPill } from "../primitives/StatusPill.js";
import { Numeric } from "../primitives/Numeric.js";
import { formatGBP, formatDate } from "../utils/format.js";
const STATUS_TONE = {
    pending_payment: "warning",
    placed: "info",
    out_for_delivery: "info",
    paid: "olive",
    fulfilled: "success",
    cancelled: "danger",
    partially_refunded: "warning",
    refunded: "neutral",
};
export function OrderRow({ id, customerName, customerHref, placedAt, totalMinor, status, cutoffMarker, statusExtra, href, className, }) {
    return (_jsxs(TR, { "data-slot": "order-row", "data-status": status, className: className, children: [_jsx(TD, { className: "font-mono text-body-sm", children: href ? (_jsx("a", { href: href, className: "text-ink-900 hover:underline", children: id })) : (id) }), _jsx(TD, { children: customerHref ? (_jsx("a", { href: customerHref, className: "text-ink-700 hover:underline", children: customerName })) : (customerName) }), _jsxs(TD, { className: "text-ink-500", children: [formatDate(placedAt), cutoffMarker ? _jsxs(_Fragment, { children: [" \u00B7 ", cutoffMarker] }) : null] }), _jsx(TD, { className: "text-end", children: _jsx(Numeric, { serif: true, children: formatGBP(totalMinor) }) }), _jsx(TD, { children: _jsxs("span", { className: "inline-flex items-center gap-1.5", children: [_jsx(StatusPill, { tone: STATUS_TONE[status], children: status.replace(/_/g, " ") }), statusExtra] }) })] }));
}
